import { Components, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiTypography to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/typography/#css
 */
export const MuiTypography: Components<Theme>['MuiTypography'] = {};
